import React from "react";
import {getDefaultState, MenuStore} from "../../stores/menu";
import {logout} from "../../actions/session";
import * as ui from "../utils/ui";
import {GlobalLoader, UnobtrusiveLoader} from "./loader";
import {connect} from "../utils/aj";
import {optional, parseBoolean, uuid} from "../../utils/lang";
import M from "../../strings";
import _, { isEmpty } from "underscore"
import {SystemStore} from "../../stores/system";
import {systemInformation} from "../../actions/system";
import globalComponents from "./extra/globalComponents"
import GlobalDialog from "./globalDialog";
import { ComponentWithTooltips } from "./common";
import { getLoggedUser } from "../../api/session";
import { isNotEmpty } from "../../framework/utils";
import { confirm } from "../../plugins";
import { MaterialIcon } from "./materialIcon";
import * as MenuUtils from "../../utils/menu";
import { clearActiveMenuItem, setActiveMenuItem } from "../../actions/menu";
import { scrollOnTop } from "../../utils/customUtils";
import { MENU_ITEM_TYPES } from "../../model/menu";

function showPageLoader() {
    $(".page-loader").show()
}

function hidePageLoader() {
    $(".page-loader").fadeOut(500)
}

class Header extends ComponentWithTooltips {

    logout() {
        confirm("Sei sicuro di voler uscire?")
            .then(logout)
            .catch(e => {
                console.log(e);
            })
    }

    onLogoClick() {
        ui.navigate("");
        clearActiveMenuItem();
    }

    onMenuItemClick(menuItem) {
        ui.navigate(menuItem.href);
        setActiveMenuItem(menuItem);
    }

    render () {
        let hideMenuToggle = parseBoolean(optional(this.props.hideMenuToggle, false)),
            user = getLoggedUser(),
            badgeContent = isNotEmpty(user) && isNotEmpty(user.fullName)
                ? _.map(user.fullName.split(" "), w => w.toUpperCase()[0]).join("")
                : "",
            menu = optional(this.props.topMenu, []),
            activeItemId = this.props.activeItemId,
            activeRoot = MenuUtils.getItemRoot(menu, activeItemId),
            menuItems = [],
            dropdownItems = [];
        
        _.each(menu, menuItem => {
            const active = isNotEmpty(activeRoot) && activeRoot.id === menuItem.id,
                onClickCallback = () => this.onMenuItemClick(menuItem);
            menuItems.push(
                <div
                    key={"header-item-" + menuItem.id}
                    className={"header__item" + (active ? " header__item--active" : "")}
                >
                    <div
                        className="header__item-action"
                        onClick={onClickCallback}
                    >
                        <MaterialIcon
                            icon={menuItem.icon}
                        />
                        <div
                            className="header__item-action-label"
                        >
                            {menuItem.text}
                        </div>
                    </div>
                </div>
            );
            dropdownItems.push(
                <a
                    key={"dropdown-item-" + menuItem.id}
                    onClick={onClickCallback}
                    className={"dropdown-item header__dropdown-item-action" + (active ? " header__dropdown-item-action--active" : "")}
                >
                    <MaterialIcon
                        icon={menuItem.icon}
                    />
                    <div
                        className="header__dropdown-item-action-label"
                    >
                        {menuItem.text}
                    </div>
                </a>
            )
        });

        return(
            <nav
                className="header clearfix"
            >
                {!hideMenuToggle && <div className={"navigation-trigger " + (this.props.sideBarHidden ? "" : "hidden-xl-up")} data-ma-action="aside-open" data-ma-target=".sidebar">
                    <div className="navigation-trigger__inner">
                        <i className="navigation-trigger__line"></i>
                        <i className="navigation-trigger__line"></i>
                        <i className="navigation-trigger__line"></i>
                    </div>
                </div>}

                <div className="header__logo">
                    <h1>
                        <a onClick={this.onLogoClick.bind(this)}>
                            <img
                                src="resources/images/logo.svg"
                                style={{height: 36, paddingTop: 4}}
                            />
                        </a>
                    </h1>
                </div>

                <div
                    className="header__spacer"
                />
                {isNotEmpty(dropdownItems) && <div className="header__nav-menu hidden-sm-up">
                    <div
                        id="navbarDropdown"
                        className="header__item dropdown"
                    >
                        <div
                            className="header__item-action dropdown-toggle"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <MaterialIcon
                                icon="more_vert"
                            />
                        </div>
                        <ul
                            className="dropdown-menu"
                            aria-labelledby="navbarDropdown"
                        >
                            {dropdownItems}
                        </ul>
                    </div>
                </div>}
                {isNotEmpty(menuItems) && <div className="header__nav-menu hidden-xs-down">
                    {menuItems}
                </div>}
                <div
                    id="badgeDropdown"
                    className="header__item header__item--user-badge dropdown"
                >
                    <div
                        className="header__user-badge dropdown-toggle"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        {badgeContent}
                    </div>
                    <ul
                        className="dropdown-menu"
                        aria-labelledby="badgeDropdown"
                    >
                        <li
                            className="dropdown-item"
                            onClick={this.logout.bind(this)}
                        >
                            {M("logout")}
                        </li>
                    </ul>
                </div>
            </nav>
        )
    }
}

/*class ProfileBox extends React.Component {

    constructor(props) {
        super(props)

        connect(this, [SessionStore, UIStore])

        this.state = {}
    }

    logout() {
        logout()
        ui.navigate("/login")
    }

    render() {
        return (
            <div className="user">
                <div className="user__info" data-toggle="dropdown">
                        {this.state.profileImage ?
                            <img className="user__img" src={this.state.profileImage} alt="" />
                            :
                            <img className="user__img" src="resources/images/ic_perm_identity.png" alt="" />
                        }
                    <div>
                        <div className="user__name">{optional(() => this.state.user.name, "NA")}</div>
                        <div className="user__email">{optional(() => this.state.user.mail, "NA")}</div>
                    </div>
                </div>

                <div className="dropdown-menu">
                    <a className="dropdown-item" onClick={this.logout.bind(this)}><i className="zmdi zmdi-time-restore"></i> Logout</a>
                </div>
            </div>
        )
    }
}*/

export class SideBar extends React.Component {
    render() {
        return (
            <aside id="sidebar" className={"sidebar " + (this.props.hidden ? "sidebar--hidden" : "")}>
                <div className="scroll-wrapper scrollbar-inner">
                    <MainMenuContainer
                        setupMenu={this.props.setupMenu}
                    />
                </div>
            </aside>
        )
    }
}

class MainMenuContainer extends React.Component {
    constructor(props) {
        super(props);
        connect(this, MenuStore, getDefaultState());
    }

    onItemClick(item) {
        const {href, onClick} = item;

        setActiveMenuItem(item);
        
        if (isNotEmpty(href)) {
            ui.navigate(href)
        }

        if (onClick && _.isFunction(onClick)) {
            onClick();
        }
    }

    render() {
        const menu = optional(this.state.menu, []),
            activeItemId = optional(this.state.activeItemId),
            activeItem = isNotEmpty(activeItemId) ? MenuUtils.getItem(menu, activeItemId) : undefined,
            activeRoot = isNotEmpty(activeItemId) ? MenuUtils.getItemRoot(menu, activeItemId) : undefined,
            activeRootItems = optional(() => activeRoot.children, []),
            backButton = optional(() => activeRoot.backButton);

        return <MainMenu
            items={activeRootItems}
            activeItem={activeItem}
            backButton={backButton}
            onItemClick={this.onItemClick.bind(this)}
        />
    }
}

class MainMenu extends React.Component {
    constructor(props) {
        super(props);
        this.uuid = uuid();
    }

    onItemClick(item) {
        if (this.props.onItemClick && _.isFunction(this.props.onItemClick)) {
            scrollOnTop();
            this.props.onItemClick(item);
        }
    }

    getBackButton() {
        const backButton = this.props.backButton;

        if (isEmpty(backButton)) {
            return undefined;
        }

        const {label, icon, action} = backButton,
            onClick = action && _.isFunction(action) ? action : () => {};

        return (<div
            className="navigation__back"
        >
            <button
                className="btn btn-lg btn-primary btn-block"
                role="button"
                onClick={onClick}
            >
                {<MaterialIcon
                    icon={icon || "arrow_back"}
                />}
                {label || M("back")}
            </button>
        </div>)
    }

    render() {
        const activeItem = this.props.activeItem,
            backButton = this.getBackButton(),
            activeItemId = optional(() => activeItem.id),
            items = optional(this.props.items, []);

        return(
            <>
                {isNotEmpty(backButton) && backButton}
                <div
                    className="navigation"
                >
                    {_.map(items, (item, index) => {
                        const {id, type} = item,
                            isActive = id === activeItemId;
                        
                        if (type === MENU_ITEM_TYPES.SEPARATOR) {
                            return (<div
                                    key={"menu-item_separator-" + index}
                                    className="navigation__sub navigation__sub--separator"
                                />)
                        } else {
                            const {icon, text} = item;
                            return (<div
                                    key={"menu-item_" + id}
                                    className={"navigation__sub" + (isActive ? " navigation__sub--active" : "")}
                                    onClick={this.onItemClick.bind(this, item)}
                                >
                                    {icon && <MaterialIcon
                                        className="navigation__sub-icon"
                                        icon={icon}
                                    />}
                                    <span>
                                        {text}
                                    </span>
                                </div>)
                        }
                    })}
                </div>
            </>
        )
    }
}

/*class MainMenuContainer extends React.Component {
    constructor(props) {
        super(props)
        connect(this, MenuStore, {menu: []})
    }

    onSelect(item) {
        setActiveMenuItem({item})
    }

    onExpand(item) {
        expandMenuItem({item})
    }

    render() {
        return <MainMenu menu={this.state.menu} onExpand={this.onExpand.bind(this)} onSelect={this.onSelect.bind(this)} />
    }
}

class MainMenu extends React.Component {
    onExpand(item) {
        if (_.isFunction(this.props.onExpand)) {
            this.props.onExpand(item)
        }
    }

    onSelect(item) {
        if (_.isFunction(this.props.onSelect)) {
            this.props.onSelect(item)
        }
    }


    render() {
        let menu = this.props.menu

        return (
            <MenuLevel menu={menu} isMainMenu="true" onExpand={this.onExpand.bind(this)} onSelect={this.onSelect.bind(this)}/>
        )
    }
}

class MenuLevel extends React.Component {
    onSelect(item, e) {
        if (item.href) {
            if (isControlPressed()) {
                window.open(item.href)
            }else {
                location.href = item.href
            }
        }

        if (_.isFunction(this.props.onSelect)) {
            this.props.onSelect(item, e)
        }

        let hasChildren = !_.isEmpty(item.children)
        if (hasChildren) {
            this.onExpand(item)
        }

        e.preventDefault();
    }

    onExpand(item) {
        if (_.isFunction(this.props.onExpand)) {
            this.props.onExpand(item)
        }
    }

    render() {
        let menu = optional(this.props.menu, [])
        let isMainMenu = optional(parseBoolean(this.props.isMainMenu), false)

        let key = 1
        let items = menu.map(i => {
            let className = ""
            if (i.active) { className += "navigation__active" }
            let hasChildren = !_.isEmpty(i.children)
            if (hasChildren) { className += " navigation__sub" }
            if (i.expanded) { className += " toggled" }

            return (
                <li key={key++} className={className}>
                    <a onClick={this.onSelect.bind(this, i)} data-ma-action={hasChildren ? "submenu-toggle" : undefined} >
                        <i className={i.icon}></i> {i.text}
                    </a>

                    {hasChildren &&
                        <MenuLevel parent={i} menu={i.children} onExpand={this.onExpand.bind(this, i)}  />
                    }
                </li>
            )
        })

        let expanded = !isMainMenu && this.props.parent.expanded === true
        let style = {}
        if (expanded) {
            style.display = "block"
        }
        let className = ""
        if (isMainMenu) {
            className += "navigation"
        } else {
            className = "navigation__sub"
        }

        return (
            <ul className={className} style={style}>
                {items}
            </ul>
        )
    }
}*/


class Footer extends React.Component {

    constructor(props) {
        super(props)
        connect(this, SystemStore, {})
    }

    componentDidMount() {
        systemInformation()
    }

    render() {
        let backendVersion = this.state.backendVersion;
        let apiVersion = this.state.apiVersion;
        let copyrightInfos = this.state.copyrightInfos;

        return (
            <footer className="footer hidden-xs-down">
                <p className="nav footer__nav">
                    {backendVersion && <span> Web: v{backendVersion}&nbsp; </span> }
                    -&nbsp;
                    {apiVersion && <span>API: v{apiVersion}&nbsp; </span>}
                    -&nbsp;
                    {copyrightInfos && <span>Copyright: {copyrightInfos}&nbsp; </span>}
                </p>
            </footer>
        )
    }
}

let GlobalTransitionTimer = null;

class LayoutTransition extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            __screen_animating: true
        }
    }

    componentDidMount() {
        if (GlobalTransitionTimer) {
            clearTimeout(GlobalTransitionTimer);
        }

        GlobalTransitionTimer = setTimeout(() => this.setState({__screen_animating: false}), 250);
    }

    render() {
        const transition = "animated animated-fast " + (this.props.transition || "fadeIn");
        let className = (this.props.className || "") + " " + (this.state.__screen_animating ? transition : "");

        return (
            <div className={className}>
                {this.props.children}
            </div>
        );
    }
}

class Layout extends React.Component {
    constructor(props) {
        super(props);
        connect(this, MenuStore, getDefaultState())
    }

    render() {
        const showHeader = !optional(this.props.hideHeader, false),
            showFooter = !optional(this.props.hideFooter, false),
            contentFull = optional(this.props.contentFull);
        /*let noContainer = optional(this.props.noContainer, false);
        let showFooter = !optional(this.props.hideFooter, false);
        let showHeader = !optional(this.props.hideHeader, false);
        let noPaddingBottom = optional(this.props.noPaddingBottom, false);*/

        return (
            <>
                {showHeader && <Header
                    topMenu={this.state.menu}
                    activeItemId={this.state.activeItemId}
                    hideMenuToggle={contentFull}
                />}

                <Body
                    className={this.props.className}
                    contentFull={contentFull}
                >
                    {this.props.children}
                </Body>

                {showFooter && <Footer/>}
            </>
        )
    }
}

class Body extends React.Component {
    render() {
        const contentFull = parseBoolean(optional(this.props.contentFull, false));
        let className = "content";

        if (contentFull) {
            className += " content--full";
        }

        if (isNotEmpty(this.props.className)) {
            className += " " + this.props.className;
        }

        return (
            <section
                className={className}
            >
                <LayoutTransition>
                        {this.props.children}
                </LayoutTransition> 
            </section>
        )
    }
}

class FullScreenLayout extends React.Component {
    render() {
        return <div>{this.props.children}</div>
    }
}


class ScreenContainer extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            currentScreen: null
        }
    }

    componentDidMount() {
        ui.addScreenChangeListener(screen => {
            //showPageLoader()
            this.setState(_.assign(this.state, {currentScreen: screen}))
            //hidePageLoader()
        })
    }

    render() {
        if (_.isEmpty(this.state.currentScreen)) {
            return <div />
        }
        return this.state.currentScreen
    }
}


class Screen extends React.Component {

}


class Index extends React.Component {
    constructor(props) {
        super(props)

        this.state = {}
    }

    render() {
        return (
            <>
                <GlobalDialog />
                <GlobalLoader />
                <UnobtrusiveLoader />
                <ScreenContainer />
                {globalComponents()}
            </>
        )
    }
}

exports.Index = Index
exports.Screen = Screen
exports.FullScreenLayout = FullScreenLayout
exports.Layout = Layout
//exports.LayoutNoMenu = LayoutNoMenu
exports.Header = Header
exports.Footer = Footer
